(function () {
  function initBlogLatest(section) {
    if (!section || section.dataset.ccBlogLatestInitialized === 'true') return;

    section.dataset.ccBlogLatestInitialized = 'true';

    const filters = Array.from(section.querySelectorAll('[data-cc-blog-filter]'));
    const cards = Array.from(section.querySelectorAll('[data-cc-blog-card]'));
    const pagination = section.querySelector('[data-cc-blog-pagination]');
    const emptyState = section.querySelector('[data-cc-blog-empty]');
    const perPage = Number(section.dataset.articlesPerPage) || 7;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    let activeCategory = 'all';
    let currentPage = 1;
    let lastTotalPages = 1;

    function getCardCategories(card) {
      return (card.dataset.categories || '')
        .split(' ')
        .map((category) => category.trim())
        .filter(Boolean);
    }

    function getFilteredCards() {
      if (activeCategory === 'all') {
        return cards;
      }

      return cards.filter((card) => getCardCategories(card).includes(activeCategory));
    }

    function setFeaturedCard(visibleCards) {
      cards.forEach((card) => {
        card.classList.remove('cc-blog-latest__card--featured');
      });

      if (visibleCards.length) {
        visibleCards[0].classList.add('cc-blog-latest__card--featured');
      }
    }

    function setActiveFilter(activeFilter) {
      filters.forEach((filter) => {
        const isActive = filter === activeFilter;

        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function goToPage(page) {
      if (currentPage === page) return;

      currentPage = page;
      renderCards();

      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    function createNavigationButton(label, page, disabled) {
      const button = document.createElement('button');
      const labelElement = document.createElement('span');

      button.type = 'button';
      button.className = 'cc-blog-latest__pagination-link';
      button.setAttribute('aria-label', label);

      labelElement.className = 'cc-blog-latest__pagination-label';
      labelElement.textContent = label;
      button.appendChild(labelElement);

      if (disabled) {
        button.disabled = true;
        button.classList.add('is-disabled');
      }

      button.addEventListener('click', () => {
        if (disabled) return;
        goToPage(page);
      });

      return button;
    }

    function createPageButton(page) {
      const button = document.createElement('button');
      const isActive = page === currentPage;

      button.type = 'button';
      button.textContent = String(page);
      button.className = 'cc-blog-latest__pagination-number';
      button.setAttribute(
        'aria-label',
        isActive ? `Page ${page}, current page` : `Go to page ${page}`
      );

      if (isActive) {
        button.classList.add('is-active');
        button.setAttribute('aria-current', 'page');
      }

      button.addEventListener('click', () => {
        goToPage(page);
      });

      return button;
    }

    function createEllipsis() {
      const ellipsis = document.createElement('span');

      ellipsis.className = 'cc-blog-latest__pagination-ellipsis';
      ellipsis.textContent = '…';
      ellipsis.setAttribute('aria-hidden', 'true');

      return ellipsis;
    }

    function getMobilePaginationItems(totalPages) {
      if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
      }

      if (currentPage <= 2) {
        return [1, 2, 3, 'ellipsis', totalPages];
      }

      if (currentPage >= totalPages - 1) {
        return [1, 'ellipsis', totalPages - 2, totalPages - 1, totalPages];
      }

      return [1, 'ellipsis', currentPage, 'ellipsis', totalPages];
    }

    function getPaginationItems(totalPages) {
      if (mobileQuery.matches) {
        return getMobilePaginationItems(totalPages);
      }

      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      lastTotalPages = totalPages;
      pagination.innerHTML = '';

      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      pagination.appendChild(
        createNavigationButton(
          'Previous',
          Math.max(1, currentPage - 1),
          currentPage === 1
        )
      );

      getPaginationItems(totalPages).forEach((item) => {
        if (item === 'ellipsis') {
          pagination.appendChild(createEllipsis());
          return;
        }

        pagination.appendChild(createPageButton(item));
      });

      pagination.appendChild(
        createNavigationButton(
          'Next',
          Math.min(totalPages, currentPage + 1),
          currentPage === totalPages
        )
      );
    }

    function renderCards() {
      const filteredCards = getFilteredCards();
      const totalPages = Math.max(1, Math.ceil(filteredCards.length / perPage));

      if (currentPage > totalPages) {
        currentPage = totalPages;
      }

      const start = (currentPage - 1) * perPage;
      const end = start + perPage;
      const pageCards = filteredCards.slice(start, end);

      cards.forEach((card) => {
        card.hidden = true;
      });

      pageCards.forEach((card) => {
        card.hidden = false;
      });

      setFeaturedCard(pageCards);

      if (emptyState) {
        emptyState.hidden = filteredCards.length > 0;
      }

      renderPagination(totalPages);
    }

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.ccBlogFilter || 'all';
        currentPage = 1;

        setActiveFilter(filter);
        renderCards();
      });
    });

    function handleViewportChange() {
      if (!section.isConnected) {
        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', handleViewportChange);
        } else if (typeof mobileQuery.removeListener === 'function') {
          mobileQuery.removeListener(handleViewportChange);
        }

        return;
      }

      renderPagination(lastTotalPages);
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleViewportChange);
    }

    // Open on a category when arriving from a tag link, such as a blog post's category.
    const initialFilter = filters.find(
      (filter) => filter.dataset.ccBlogFilter === section.dataset.activeCategory
    );

    if (initialFilter) {
      activeCategory = initialFilter.dataset.ccBlogFilter;
      setActiveFilter(initialFilter);
    }

    renderCards();
  }

  function initAllBlogLatestSections() {
    document.querySelectorAll('[data-cc-blog-latest]').forEach(initBlogLatest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBlogLatestSections);
  } else {
    initAllBlogLatestSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBlogLatest(event.target.querySelector('[data-cc-blog-latest]'));
  });
})();
